import context from '@truckdown/components-systems';
import registerLocations from '@truckdown/locations';
import registerAccounts from '@truckdown/accounts';
import registerPromotions from '@truckdown/promotions';
import registerBilling from '@truckdown/billing';
import prerequisites from '@truckdown/components-locations';

registerLocations(context);
registerAccounts(context);
registerPromotions(context);
registerBilling(context);

prerequisites.registerPrerequisites(context);

import './empty-banner.png';
import './Images/truck.png';
import './Images/towing_header.png';
import './Images/truck_tire_header.png';

import './Components';
import './Styles/main.less';

context.initialize().then(() => {
    console.log('System initialized');
});
